import React, {Component} from 'react';
import PropTypes from 'prop-types';
import * as R from 'ramda';
import {DisplayMode} from './controls_helper';

// Components
import SortByDropdown from './sort_by_dropdown';
import DateRangePicker from './date_range_picker';
import ContentFiltersDropdown from './content_filters_dropdown';
import ContentTypeSelector from './content_type_selector';
import ViewSelector from './view_selector';
import Toggle from './toggle';

class PostsControlsRow extends Component {
    componentDidCatch(error) {
        console.error(error);
    }
    
    displaySortByDropdown() {    
        const {currentDisplayMode} = this.props;

        return currentDisplayMode === DisplayMode.GRID ? (
            <SortByDropdown
                currentSortColumn={this.props.currentSortColumn}
                sortByProperty={this.props.sortByProperty}
                showKoer={this.props.showKoer}
            />
        ) : null;
    }

    displayContentFiltersDropdown() {
        const {
            changeIncludeContentFilter,
            changeExcludeContentFilter,
            currentDisplayMode,
            excludeContentFilters,
            includeContentFilters
        } = this.props;

        return currentDisplayMode === DisplayMode.GRID ? (
            <div className="content-filters-container">
                <ContentFiltersDropdown
                    changeIncludeContentFilter={changeIncludeContentFilter}
                    changeExcludeContentFilter={changeExcludeContentFilter}
                    currentDisplayMode={currentDisplayMode}
                    excludeContentFilters={excludeContentFilters}
                    includeContentFilters={includeContentFilters}
                />
            </div>
        ) : null;
    }

    displayDatePicker() {
        const {displayDatePicker} = this.props;

        if (displayDatePicker) {
            return (
                <div id="date-range-picker">
                    <DateRangePicker
                        onChange={this.props.handleDateRangeChange}
                        showBidAndBudgetRow={this.props.showBidAndBudgetRow}
                        selectedStart={this.props.selectedStart}
                        selectedEnd={this.props.selectedEnd}
                        dateSelectedIdx={this.props.dateSelectedIdx}
                        dateSelectActive={this.props.dateSelectActive}
                    />
                </div>
            );
        }
    }

    displayRateCreatorsToggle = () => {
        const {showRateCreatorsToggle, changeRateCreatorsMode} = this.props;

        if (showRateCreatorsToggle) {
            return (
                <div className="pull-right">
                    <Toggle onChange={changeRateCreatorsMode} />
                </div>
            );
        }
    };

    render() {
        const {
            changeContentType,
            changeViewMode,
            currentContentType,
            currentDisplayMode,
        } = this.props;
        const contentFiltersDropdown = this.displayContentFiltersDropdown();
        const sortByDropdown = this.displaySortByDropdown();
        const datePicker = this.displayDatePicker();

        return (
            <div className="posts-actions-container">
                {contentFiltersDropdown}
                {sortByDropdown}
                {datePicker}
                <ContentTypeSelector
                    changeContentType={changeContentType}
                    currentContentType={currentContentType}
                />
                <ViewSelector
                    currentDisplayMode={currentDisplayMode}
                    changeViewMode={changeViewMode}
                />

                {this.displayRateCreatorsToggle()}
            </div>
        );
    }
}

PostsControlsRow.propTypes = {
    changeContentType: PropTypes.func.isRequired,
    changeIncludeContentFilter: PropTypes.func.isRequired,
    changeExcludeContentFilter: PropTypes.func.isRequired,
    changeCardSize: PropTypes.func.isRequired,
    changeViewMode: PropTypes.func.isRequired,
    showRateCreatorsToggle: PropTypes.bool.isRequired,
    changeRateCreatorsMode: PropTypes.func.isRequired,
    clearFilter: PropTypes.func.isRequired,
    currentContentType: PropTypes.string.isRequired,
    currentSliderPosition: PropTypes.number.isRequired,
    currentSortColumn: PropTypes.string,
    currentDisplayMode: PropTypes.string.isRequired,
    excludeContentFilters: PropTypes.array.isRequired,
    includeContentFilters: PropTypes.array.isRequired,
    sortByProperty: PropTypes.func.isRequired,
    campaignId: PropTypes.number.isRequired,
    posts: PropTypes.array.isRequired,
    isAdmin: PropTypes.bool,
};

export default PostsControlsRow;



// WEBPACK FOOTER //
// ./campaign_analytics/v2/campaign_analytics_page/posts/posts_controls_row/index.js